<template>
  <sc-page-base title="Adicionar método">
    <new-logistic-provider-form :shouldIntegrationLp="false" />
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
  } from '@intelipost-js/secure-components';

  import NewLogisticProviderForm from '../logistic-provider-form/NewLogisticProviderForm.vue';

  export default {
    name: 'new-quote-table-page',
    components: {
      ScPageBase,
      NewLogisticProviderForm,
    },
  };
</script>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/add-delivery-method/AddDeliveryMethodPage.vue?70f51164